import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter, Route, Routes, Outlet, useLocation, useParams } from "react-router-dom";
import { VideoProvider } from "./Context/VideoContext";
import GlobalFloatingPlayer from "./Kurs/GlobalFloatingPlayer";
import { FaChartPie } from "react-icons/fa";
import Menyu from "./Menyu";
import Qiymat from "./Qiymat";
import Foydalanuvchi from "./Foydalanuvchi";
import "./Loyiha.css";
import MBicon from "./Yuklash/icon";
import rasmKod from "./Rasm/js.png";
import logoSuvoriy from "./Rasm/suvoriy-logo.png";

import Masala from "./Masala";
import Kurs from "./Kurs";
import Topilmadi from "./Topilmadi";

import DarsSahifa from "./Kurs/DarsSahifa";
import Bosh from "./Bosh";
import Kirish from "./Kirish";
import Landing from "./Landing";
import Yangilik from "./Yangilik/Yangilik";


import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CONFIG from "./config";
import Verify from "./Verify";
import VerifyId from "./VerifyId";
import NotificationModal from "./Foydalanuvchi/NotificationModal";
import SpecialNotifCard from "./Foydalanuvchi/SpecialNotifCard";
import Kitoblar from "./Kitoblar/Kitoblar";
import KitobBatafsil from "./Kitoblar/KitobBatafsil";

const API_BASE_URL = CONFIG.API_BASE_URL;


const iconlar = MBicon.map((qiymat) => {
  return qiymat;
});

// Need to pass 'kurslar' to MainLayout to show in UserPanel
function MainLayout({ iconlar, toggleUserPanel, userPanelOpen, darkMode, toggleDarkMode, userData, kurslar, refreshUserData, openNotifs, darajalar }) {
  const location = useLocation();
  const isLearningLayout = location.pathname.startsWith("/kurs-dars") || location.pathname === "/mantiq";

  return (
    <div className={`quti ${isLearningLayout ? "learning-layout" : ""} ${userPanelOpen ? "sidebar-open" : ""}`}>

      <Menyu iconlar={iconlar} toggleUserPanel={toggleUserPanel} darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      <Outlet />
      <Foydalanuvchi
        isOpen={userPanelOpen}
        toggleUserPanel={toggleUserPanel}
        darkMode={darkMode}
        toggleDarkMode={toggleDarkMode}
        userData={userData}
        kurslar={kurslar} // Pass courses!
        refreshData={refreshUserData} // Pass refresh function!
        openNotifs={openNotifs} // Global open notifs
        darajalar={darajalar}
      />
      {userPanelOpen && (
        <div
          className="overlay"
          onClick={() => toggleUserPanel()}
        ></div>
      )}
      {!isLearningLayout && (
        <div className="floating-toggle" onClick={toggleUserPanel}>
          <FaChartPie className="spinning-icon" />
        </div>
      )}
    </div>
  );
}





function Loyiha() {
  const [kurslar, setKurslar] = useState([]);
  const [mavzu, setMavzu] = useState([]); // This will now hold topics for the selected course only
  const [loading, setLoading] = useState(true);
  const [loadingTopics, setLoadingTopics] = useState(false);
  const [error, setError] = useState(null); // New error state
  const [userData, setUserData] = useState(null); // User balance/score
  const [showNotifModal, setShowNotifModal] = useState(false);
  const [activeSpecialNotifs, setActiveSpecialNotifs] = useState([]);
  const [dismissedThisSession, setDismissedThisSession] = useState([]);
  const [darajalar, setDarajalar] = useState([]);

  const [kurs_id, setKurs_id] = useState(0);
  const [kurs, setKurs] = useState("");
  const [baza, setBaza] = useState("");
  const [html, setHtml] = useState("");
  const [css, setCss] = useState("");
  const [js, setJs] = useState("");

  const [userPanelOpen, setUserPanelOpen] = useState(() => {
    const saved = localStorage.getItem("loyiha_userPanelOpen");
    return saved !== null ? JSON.parse(saved) : false;
  });
  const [activeMavzu, setActiveMavzu] = useState(0);
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem("loyiha_darkMode");
    return saved !== null ? JSON.parse(saved) : false;
  });
  const [isHydrated, setIsHydrated] = useState(false);

  // 1. Initial Load: Fetch ALL courses and User Data
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const token = localStorage.getItem("loyiha_token");
        const path = window.location.pathname.replace(/\/$/, "");

        // If no token on protected route, let LoyihaContent handle redirect
        if (!token && path !== "" && path !== "/" && path !== "/kirish" && !path.startsWith("/verify") && !path.startsWith("/verify-id")) {
          setLoading(false);
          return;
        }

        // Get User ID from localStorage if available (for robust API check)
        const storedUser = JSON.parse(localStorage.getItem("loyiha_user") || "{}");
        const storedUserId = storedUser.id || 0;

        setLoading(true);
        const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
        const res = await fetch(`${API_BASE_URL}/get_umumiy_baza.php?token=${encodeURIComponent(token || '')}&user_id=${storedUserId}`, { headers }).then(r => r.json());

        if (res.status === 'success') {
          // Process Kurslar
          const processed = res.kurslar.map(k => ({
            ...k,
            id: parseInt(k.id),
            turi: parseInt(k.turi),
            rasm: k.rasm.startsWith('.') ? k.rasm.replace('./', '/') : k.rasm,
            video: k.video.startsWith('.') ? k.video.replace('./', '/') : k.video,
            sotib_olingan: k.sotib_olingan,
            completed_lessons: k.completed_lessons,
            total_score: k.total_score,
            total_lessons_calc: k.total_lessons_calc
          }));
          setKurslar(processed);
          if (res.darajalar) setDarajalar(res.darajalar.map(d => d.nomi));

          // Process User Data & Rank
          if (res.user) {
            // Merge rank data into user data object for simpler downstream prop passing
            const combinedUser = {
              ...res.user,
              rank: res.rank || {}
            };
            setUserData(combinedUser);
          } else if (token) {
            // Token sent but user is null/missing -> Token is invalid
            if (!path.startsWith("/verify") && !path.startsWith("/verify-id")) {
              handleLogout();
              return;
            }
          }
        } else if (token) {
          // status !== 'success' but we had a token
          if (!path.startsWith("/verify") && !path.startsWith("/verify-id")) {
            handleLogout();
            return;
          }
        }

        // Removed redundant refreshUserData() call, as get_initial_data returns user data

        setLoading(false);

        setLoading(false);
      } catch (err) {
        console.error("Load error:", err);
        setError(`Server bilan bog'lanishda xatolik yuz berdi: ${err.message || 'Noma\'lum xato'}. Iltimos, keyinroq qayta urinib ko'ring.`);
        setLoading(false);
      }
    };
    fetchInitialData();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("loyiha_token");
    localStorage.removeItem("loyiha_user");
    setUserData(null);
    window.location.href = "/kirish";
  };
  // Sync user name to localStorage whenever userData updates
  useEffect(() => {
    if (userData && (userData.ism || userData.foydalanuvchi_ismi)) {
      localStorage.setItem('loyiha_user_name', userData.ism || userData.foydalanuvchi_ismi);
    }
  }, [userData]);

  // Special Notification Trigger (Birthday, Holidays, etc.)
  useEffect(() => {
    const checkSpecialNotifs = async () => {
      if (userData) {
        // Fetch notifications to see if there's an unread SPECIAL one
        try {
          const token = localStorage.getItem("loyiha_token");
          const res = await fetch(`${API_BASE_URL}/get_notifications.php?token=${token}`, {
            headers: { 'Authorization': `Bearer ${token}` }
          }).then(r => r.json());

          if (res.status === 'success') {
            // Collect all unread special notifications
            const specials = res.data.filter(n => {
              const isSpecialType = n.turi === 'gift' || n.id.toString().startsWith('b_') || n.id.toString().startsWith('h_') || n.id.toString().startsWith('welcome_');
              const isUnread = !n.oqildi;
              const isNotDismissed = !dismissedThisSession.includes(n.id);
              return isUnread && isNotDismissed;
            });

            setActiveSpecialNotifs(specials);
          }
        } catch (e) {
          console.error("Special notif check error:", e);
        }
      }
    };
    checkSpecialNotifs();
  }, [userData]);

  const refreshUserData = async () => {
    try {
      const token = localStorage.getItem("loyiha_token");
      const user = JSON.parse(localStorage.getItem("loyiha_user") || "{}");
      if (!token) return;

      const userId = user.id ? user.id : 0;

      // Fetch User Profile
      const userRes = await fetch(`${API_BASE_URL}/get_user_data.php?user_id=${userId}&token=${token}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      }).then(r => r.json());

      if (userRes.status === 'success') {
        const userData = userRes.data;
        setUserData(userData);
        // Save name for Video Watermark (as backup)
        localStorage.setItem('loyiha_user_name', userData.ism || userData.foydalanuvchi_ismi || '');
      } else {
        console.warn("Auth error in refreshUserData:", userRes.message);
        const path = window.location.pathname.replace(/\/$/, "");
        if (!path.startsWith("/verify") && !path.startsWith("/verify-id")) {
          handleLogout();
        }
        return;
      }

      // Sync Courses (Purchase Status) - Only fetch if explicitly needed or forced
      // For now, we trust initial load. If buying course, we might need to re-fetch courses OR just update local state.
      // To optimize: We can just fetch user data here.
      // If purchase happens, we should probably fetch everything or just specific course.
      // Given user request "optimize redundant calls", removing this secondary fetch for general "refreshUser" events unless strictly necessary.
      // But wait, if user buys a course, "sotib_olingan" status changes in kurslar list?
      // Yes. So we do need to update course list IF this is called after purchase.
      // But on initial load, we don't need it because get_initial_data did it.

      // OPTIMIZATION: We can make this optional or rely on get_initial_data for first load.
      // Since first load now uses get_initial_data, refreshUserData won't be called there.
      // So if refreshUserData IS called (e.g. periodically or after action), we DO want to sync.
      // BUT, let's keep it for now as it's separate from initial load. The REDUNDANCY was calling both on load.
      // I have removed the call to refreshUserData() in fetchInitialData().
      // So this function is now only used for UPDATES.
      // So correct logic is to KEEP it, ensuring it updates everything.

      const kursRes = await fetch(`${API_BASE_URL}/get_kurslar.php?token=${token}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      }).then(r => r.json());

      if (kursRes.status === 'success') {
        const processed = kursRes.data.map(k => ({
          ...k,
          id: parseInt(k.id),
          turi: parseInt(k.turi),
          rasm: k.rasm.startsWith('.') ? k.rasm.replace('./', '/') : k.rasm,
          video: k.video.startsWith('.') ? k.video.replace('./', '/') : k.video
        }));
        setKurslar(processed);
      }

    } catch (e) {
      console.error("Data refresh error:", e);
    }
  };

  // Periodic token and inactivity check (every 5 seconds)
  useEffect(() => {
    // Initial activity set if not exists
    if (!localStorage.getItem("loyiha_lastActivity")) {
      localStorage.setItem("loyiha_lastActivity", Date.now().toString());
    }

    const interval = setInterval(() => {
      const token = localStorage.getItem("loyiha_token");
      const path = window.location.pathname.replace(/\/$/, "");
      const lastActivity = parseInt(localStorage.getItem("loyiha_lastActivity") || Date.now().toString());
      const currentTime = Date.now();
      const inactivityLimit = 3600000; // 1 hour in milliseconds

      // If we are on a protected route...
      if (path !== "" && path !== "/" && path !== "/kirish") {
        // 1. Check if token is gone
        if (!token) {
          // handleLogout();
          console.warn("Interval logout suppressed (No Token)");
        }
        // 2. Check if inactivity limit reached
        else if (currentTime - lastActivity > inactivityLimit) {
          // handleLogout();
          console.warn("Interval logout suppressed (Inactivity)");
        }
      }
    }, 5000);

    // Activity listeners to update last activity time
    const updateActivity = () => {
      localStorage.setItem("loyiha_lastActivity", Date.now().toString());
    };

    const events = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'];
    events.forEach(event => {
      window.addEventListener(event, updateActivity);
    });

    return () => {
      clearInterval(interval);
      events.forEach(event => {
        window.removeEventListener(event, updateActivity);
      });
    };
  }, []);

  // 2. Data Synchronization based on URL (Runs when kurslar loads OR location changes)
  // This is handled in LoyihaContent via props

  // 3. Selective Fetch: Topics only for active kurs_id
  const abortControllerRef = useRef(null);

  // 3. Imperative Topic Fetch Trigger (passed to children)
  const fetchMavzular = async (targetKursId, isRefresh = false) => {
    // 1. Cancel any previous pending requests immediately
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // 2. Guard: If ID is 0 or invalid, stop here (after aborting previous)
    if (!targetKursId || targetKursId == 0) {
      setMavzu([]);
      return;
    }

    // 3. Start new request
    const controller = new AbortController();
    abortControllerRef.current = controller;

    setLoadingTopics(true);
    // Optimization: If refreshing (after test), DON'T clear array to avoid UI flicker
    if (!isRefresh) {
      setMavzu([]);
      setIsHydrated(false);
    }

    try {
      const token = localStorage.getItem("loyiha_token");
      const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
      const res = await fetch(`${API_BASE_URL}/get_mavzular.php?kurs_id=${targetKursId}&token=${token}`, {
        headers,
        signal: controller.signal
      }).then(r => r.json());

      if (res.status === 'success') {
        setMavzu(res.data);
      } else {
        setMavzu([]);
        // Handle token errors - check common messages from backend
        const isAuthError = res.message === 'Token expired' ||
          res.message === "Token noto'g'ri yoki eskirgan" ||
          res.message === "Token berilmagan";

        if (token && isAuthError) {
          handleLogout();
        }
      }
    } catch (err) {
      if (err.name === 'AbortError') {
        console.log("Fetch aborted");
      } else {
        console.error("Mavzu load error:", err);
        setMavzu([]);
      }
    } finally {
      // Only turn off loading if this is the ACTIVE request
      if (abortControllerRef.current === controller) {
        setLoadingTopics(false);
      }
    }
  };

  // RESTORED: Reactive fetch for refresh/navigation support
  // Guard clause inside fetchMavzular prevents 0-id fetches (searching).
  useEffect(() => {
    fetchMavzular(kurs_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kurs_id]);

  // Apply dark mode class to body
  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
    localStorage.setItem("loyiha_darkMode", JSON.stringify(darkMode));
  }, [darkMode]);

  useEffect(() => {
    localStorage.setItem("loyiha_userPanelOpen", JSON.stringify(userPanelOpen));
  }, [userPanelOpen]);

  const toggleUserPanel = () => {
    setUserPanelOpen(!userPanelOpen);
  };

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  const mavzuSoni = mavzu ? mavzu.length : 0;

  function Natija(html = "", css = "", js = "") {
    setBaza(`
      <html> 
      <body>${html}</body>
      <style>${css}</style>
      <script>
       function chop(nom) {
         document.write(nom);
       } 
      </script>    
      <script>
       ${js}       
      </script>
      </html>
      `);
  }

  if (loading || error) {
    return (
      <div className="loading-screen">
        <div className="loader-container">
          <div className="logo-wrapper">
            <div className="loader-ring"></div>
            <div className="loader-logo">
              <img src={logoSuvoriy} alt="Suvoriy Logo" />
            </div>
          </div>
          <p className="loading-text" style={{ color: error ? "#e74c3c" : "#333" }}>
            {error ? error : "Ma'lumotlar yuklanmoqda..."}
          </p>
          {error && (
            <button
              onClick={() => console.log("Reload suppressed by debugger")}
              style={{
                marginTop: "20px",
                padding: "10px 25px",
                backgroundColor: "rgb(141, 71, 21)",
                border: "none",
                borderRadius: "20px",
                color: "#fff",
                fontWeight: "bold",
                cursor: "pointer",
                boxShadow: "0 4px 15px rgba(141, 71, 21, 0.4)"
              }}
            >
              Qayta yuklash
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <VideoProvider>
      <BrowserRouter>
        <GlobalFloatingPlayer />
        <LoyihaContent
          iconlar={iconlar}
          kurslar={kurslar} // Pass all kurslar for lookup
          mavzu={mavzu}
          kurs_id={kurs_id}
          setKurs_id={setKurs_id}
          fetchMavzular={fetchMavzular} // Added imperative fetcher
          kurs={kurs}
          setKurs={setKurs}
          baza={baza}
          setBaza={setBaza}
          html={html}
          setHtml={setHtml}
          css={css}
          setCss={setCss}
          js={js}
          setJs={setJs}
          userPanelOpen={userPanelOpen}
          setUserPanelOpen={setUserPanelOpen}
          activeMavzu={activeMavzu}
          setActiveMavzu={setActiveMavzu}
          toggleUserPanel={toggleUserPanel}
          mavzuSoni={mavzuSoni}
          Natija={Natija}
          darkMode={darkMode}
          toggleDarkMode={toggleDarkMode}
          userData={userData}
          refreshUserData={refreshUserData}
          handleLogout={handleLogout}
          isHydrated={isHydrated}
          setIsHydrated={setIsHydrated}
          openNotifs={() => setShowNotifModal(true)}
          activeSpecialNotifs={activeSpecialNotifs}
          setDismissedThisSession={(ids) => setDismissedThisSession([...dismissedThisSession, ...ids])}
          darajalar={darajalar}
        />
        <NotificationModal
          isOpen={showNotifModal}
          onClose={(didRead) => {
            setShowNotifModal(false);
            if (didRead) refreshUserData();
          }}
        />

        {activeSpecialNotifs.length > 0 && (
          <SpecialNotifCard
            notifs={activeSpecialNotifs}
            onClose={(dismissedIds) => {
              if (dismissedIds && dismissedIds.length > 0) {
                setDismissedThisSession(prev => [...prev, ...dismissedIds]);
              }
              setActiveSpecialNotifs([]);
              refreshUserData(); // Refresh to update unread count
            }}
          />
        )}
        <ToastContainer position="top-center" autoClose={5000} />
      </BrowserRouter>
    </VideoProvider>
  );
}

function LoyihaContent({
  iconlar, kurslar, mavzu, kurs_id, setKurs_id, fetchMavzular, kurs, baza, html, setHtml, css, setCss, js, setJs,
  userPanelOpen, setUserPanelOpen, activeMavzu, setActiveMavzu, toggleUserPanel,
  mavzuSoni, Natija, darkMode, toggleDarkMode, userData, refreshUserData, handleLogout,
  isHydrated, setIsHydrated, openNotifs, darajalar
}) {
  const location = useLocation();
  console.log("LoyihaContent Render - Path:", location.pathname);

  // Smart Resume: Set active topic based on user progress OR saved state
  useEffect(() => {
    if (mavzu && mavzu.length > 0 && kurs_id !== 0) {
      const savedIndex = localStorage.getItem(`loyiha_activeMavzu_${kurs_id}`);

      if (savedIndex !== null && parseInt(savedIndex) < mavzu.length) {
        setActiveMavzu(parseInt(savedIndex));
      } else {
        // Find first unpassed topic
        const nextIndex = mavzu.findIndex(m => !m.is_passed);
        // If found (not -1), set it. If all passed (-1), default to 0.
        setActiveMavzu(nextIndex !== -1 ? nextIndex : 0);
      }
      setIsHydrated(true); // Now we are ready to persist updates
    }
  }, [mavzu, kurs_id, setActiveMavzu, setIsHydrated]);
  // Persist current lesson choice - ONLY AFTER HYDRATED
  useEffect(() => {
    if (isHydrated && kurs_id !== 0 && mavzu && mavzu.length > 0) {
      localStorage.setItem(`loyiha_activeMavzu_${kurs_id}`, activeMavzu);
    }
  }, [activeMavzu, kurs_id, mavzu, isHydrated]);

  useEffect(() => {
    console.log("Loyiha Navigation Effect Triggered - Path:", location.pathname);
    // 0. Route Protection
    const path = location.pathname.replace(/\/$/, "");
    const token = localStorage.getItem("loyiha_token");

    // Allow public access ONLY to Landing (/), Kirish (/kirish), and Verify (/verify)
    if (!token && path !== "" && path !== "/" && path !== "/kirish" && !path.startsWith("/verify") && !path.startsWith("/verify-id")) {
      window.location.href = "/kirish"; // Redirect to login
      return;
    }

    // Re-verify token on every navigation if we have a token
    // OPTIMIZED: Removed automatic refreshUserData() call to prevent redundant API requests on navigation.
    // Data is already loaded on initial app load.
    // Only verify presence of token locally.
    /*
    if (token && path !== "" && path !== "/" && path !== "/kirish") {
      refreshUserData();
    }
    */

    if (kurslar.length === 0) return;


    // 1. URL base kurs selection (e.g., from direct link or slug)
    if (path.startsWith("/kurs-dars/")) {
      const slug = path.split("/").pop().toLowerCase();
      const detected = kurslar.find(k => k.nomi.toLowerCase().replace(/ /g, "-") === slug);
      if (detected && detected.id !== kurs_id) {
        setKurs_id(detected.id);
        // ActiveMavzu will be set by the new useEffect when mavzu loads
      }
    }
    // 2. Category base auto-selection
    else {
      let targetTuri = null;
      if (path === "/algoritm") targetTuri = 1;
      else if (path === "/web") targetTuri = 2;
      else if (path === "/mobil") targetTuri = 3;

      if (targetTuri) {
        const categoryCourses = kurslar.filter(k => k.turi === targetTuri || (targetTuri === 2 && k.turi === 4));
        const isCurrentInCat = categoryCourses.some(k => k.id === kurs_id);
        if (!isCurrentInCat && categoryCourses.length > 0) {
          setKurs_id(categoryCourses[0].id);
          // ActiveMavzu will be set by the new useEffect when mavzu loads
        }
      }
    }

    // Sidebar and Scroll management
    const savedSidebar = localStorage.getItem("loyiha_userPanelOpen");
    if (savedSidebar === null) {
      if (path.startsWith("/kurs-dars")) setUserPanelOpen(false);
      else if (path === "/mantiq") setUserPanelOpen(true);
    }
    if (path === "" || path === "/") document.body.classList.add("is-landing");
    else document.body.classList.remove("is-landing");

  }, [location.pathname, kurslar.length, kurs_id]);

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/kirish" element={<Kirish />} />
      <Route path="/verify/:fio/:stars/:solved/:coins" element={<Verify />} />
      <Route path="/verify-id/:id" element={<VerifyId />} />
      <Route
        element={
          <MainLayout
            iconlar={iconlar}
            toggleUserPanel={toggleUserPanel}
            userPanelOpen={userPanelOpen}
            darkMode={darkMode}
            toggleDarkMode={toggleDarkMode}
            userData={userData}
            kurslar={kurslar}
            refreshUserData={refreshUserData}
            openNotifs={openNotifs}
            darajalar={darajalar}
          />
        }
      >
        <Route path="/bosh" element={<Bosh kurslar={kurslar} setKurs_id={setKurs_id} />} />
        <Route path="/yangilik" element={<Yangilik />} />

        <Route path="/kitob" element={<Kitoblar />} />
        <Route path="/kitob/:id" element={<KitobBatafsil />} />
        <Route
          exact
          path="/algoritm"
          element={
            <Qiymat
              kurslar={kurslar.filter(k => k.turi === 1)}
              mavzu={mavzu}
              mavzuSoni={mavzuSoni}
              setKurs_id={setKurs_id}
              fetchMavzular={fetchMavzular} // Pass imperative fetcher
              kurs_id={kurs_id}
              filterType="algoritm"
              activeMavzu={activeMavzu}
              setActiveMavzu={setActiveMavzu}
              userData={userData}
              refreshUserData={refreshUserData}
              handleLogout={handleLogout}
              darajalar={darajalar}
            />
          }
        />
        <Route
          exact
          path="/web"
          element={
            <Qiymat
              kurslar={kurslar.filter(k => k.turi === 2 || k.turi === 4)}
              mavzu={mavzu}
              mavzuSoni={mavzuSoni}
              setKurs_id={setKurs_id}
              fetchMavzular={fetchMavzular} // Pass imperative fetcher
              kurs_id={kurs_id}
              filterType="web"
              activeMavzu={activeMavzu}
              setActiveMavzu={setActiveMavzu}
              userData={userData}
              refreshUserData={refreshUserData}
              handleLogout={handleLogout}
              darajalar={darajalar}
            />
          }
        />
        <Route
          exact
          path="/mobil"
          element={
            <Qiymat
              kurslar={kurslar.filter(k => k.turi === 3)}
              mavzu={mavzu}
              mavzuSoni={mavzuSoni}
              setKurs_id={setKurs_id}
              kurs_id={kurs_id}
              filterType="mobile"
              activeMavzu={activeMavzu}
              setActiveMavzu={setActiveMavzu}
              userData={userData}
              refreshUserData={refreshUserData}
              handleLogout={handleLogout}
              darajalar={darajalar}
            />
          }
        />
        <Route
          path="/kurs-dars/:slug"
          element={
            <DarsSahifa
              kurslar={kurslar.find(k => k.id === kurs_id) || {}}
              allKurslar={kurslar}
              mavzu={mavzu}
              activeMavzu={activeMavzu}
              setActiveMavzu={setActiveMavzu}
              toggleUserPanel={toggleUserPanel}
              userPanelOpen={userPanelOpen}
              handleLogout={handleLogout}
              userData={userData}
              fetchMavzular={fetchMavzular}
            />
          }
        />
        <Route
          path="/kurs-dars"
          element={
            <DarsSahifa
              kurslar={kurslar.find(k => k.id === kurs_id) || {}}
              allKurslar={kurslar}
              mavzu={mavzu}
              activeMavzu={activeMavzu}
              setActiveMavzu={setActiveMavzu}
              toggleUserPanel={toggleUserPanel}
              userPanelOpen={userPanelOpen}
              handleLogout={handleLogout}
              userData={userData}
              fetchMavzular={fetchMavzular}
            />
          }
        />
        <Route
          path="/mantiq"
          element={
            <Masala
              baza={baza}
              setHtml={setHtml}
              setCss={setCss}
              setJs={setJs}
              html={html}
              css={css}
              js={js}
              rasm={rasmKod}
              Natija={Natija}
              toggleUserPanel={toggleUserPanel}
              userPanelOpen={userPanelOpen}
              darkMode={darkMode}
              refreshUserData={refreshUserData}
              userData={userData}
            />
          }
        />
        <Route
          path={`/kurs/${kurs}`}
          element={
            <Kurs
              baza={baza}
              kurs={kurs}
              setHtml={setHtml}
              setCss={setCss}
              setJs={setJs}
              html={html}
              css={css}
              js={js}
              rasm={rasmKod}
              Natija={Natija}
            />
          }
        />
        <Route path="*" element={<Topilmadi />} />
      </Route>
    </Routes>
  );
}


export default Loyiha;
